<template>
  <div>
    <b-row>
      <b-col>
        <b-button variant="outline" @click="logOut()">
          <i class="fa fa-power-off fa-lg"></i>
        </b-button>
      </b-col>
      <b-col class="dropdown-fit-content">
        <AppHeaderDropdown right no-caret>
          <template slot="header">
            <img v-if="img === 'null'" src="img/avatars/avatar-2-64.png" class="img-avatar" />
            <img v-else :src="img" class="img-avatar" />
          </template>
          <template slot="dropdown" >
            <b-dropdown-header tag="div" class="text-center">
              <strong>Cuenta</strong>
            </b-dropdown-header>
            <b-dropdown-item :disabled="true">
              <i class="fa fa-user text-info" />
              {{role_name}} - {{user_name}}
            </b-dropdown-item>
            <b-dropdown-item :disabled="true">
              <i class="fa fa-building text-success" />
              <b>Sucursal:</b> {{branch_office_name}}
            </b-dropdown-item>
            <b-dropdown-item @click="logOut()">
              <i class="fa fa-lock text-danger" /> Salir
            </b-dropdown-item>
          </template>
        </AppHeaderDropdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      img: localStorage.getItem("auth_image")
        ? localStorage.getItem("auth_image")
        : null,
      role_name: null,
      user_name: null,
      branch_office_name: null,
    };
  },
  created() {
    let auth = localStorage.getItem("auth");
    auth = JSON.parse(auth);
    this.user_name = auth[0].name;
    this.role_name = auth[0].role_name;
    this.branch_office_name = auth[0].branch_office_name == null ? "Sin asignar" : auth[0].branch_office_name;
  },
  methods: {
    logOut() {
      showLoader();

      this.$http
        .post(`${this.$urlApi}auth/logout?token=${this.token}`, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          localStorage.clear();
          sessionStorage.clear();
          //this.$router.push('login') // redireccionar al login
          location.href = `${location.origin}/#/login`;
          location.reload();
        })
        .catch((error) => {
          hideLoader();

          console.log(error);

          if (error.status === 401 && error.statusText === "Unauthorized") {
            localStorage.clear();
            location.reload();
          }
        });
    },
  },
};
</script>
